import React from "react";
import { Button } from "cuvama-ui";
import { useString as s } from "../StringProvider";
import { useCuvamaDiscoveryLink } from "../../providers/cuvamaDiscoveryLinkProvider";
import SyncStatusIndicator from "./syncStatusIndicator";
import Tooltip from "../Tooltip";
import styled from "styled-components";

const OpenDiscoveryReportButton = () => {
  const { cuvamaDiscoveryLink } = useCuvamaDiscoveryLink();

  const buttonTooltip = s(
    "discovery.header.openDiscoveryReport.tooltip",
    "Open Discovery Report"
  );
  const buttonText = s("discovery.header.openDiscoveryReport.label", "Open");

  if (!cuvamaDiscoveryLink) {
    return null;
  }

  const onClick = () => {
    window.location.href = cuvamaDiscoveryLink.url;
  };

  return (
    <ButtonContainer>
      <SyncStatusIndicator />
      <Tooltip title={buttonTooltip}>
        <Button
          buttonType="filled"
          buttonSize="small"
          onClick={onClick}
          data-cy="open-discovery-report-button"
        >
          {buttonText}
        </Button>
      </Tooltip>
    </ButtonContainer>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px;
  border-radius: 6px;
  border: 1px solid var(--button-stroke-border);
  margin-left: 12px;
`;

export default OpenDiscoveryReportButton;
